export default {
	contracts: 'contracts',
	delivery: 'delivery',
	'add-contract': 'Add contract',
	'edit-contract': 'Edit contract',
	
	'add-delivery': 'Add delivery',
	'edit-delivery': 'Edit delivery',
	'preview-delivery': 'Preview delivery',
	deliver: 'Deliver',
	'cancel-delivery': 'Cancel delivery',

	all: 'All',
	'not-completed': 'Not completed',
	completed: 'Completed',
	other: 'Other',

	total: 'Total',
	'total-sales': 'Total sales',
	'sale-balance': 'Expected qty',
	'remaining-qty': 'Inventory qty',
	'available-to-sell': 'Able to sell',
	'are-you-sure-the-contract-is-complete': 'Are you sure the contract is complete?',
	'mark-as-completed': 'Mark as completed',
	'mark-as-incomplete': 'Mark as incomplete',
	'are-you-sure-the-contract-is-incomplete': 'Are you sure the contract is incomplete?'
}